import Marionette from "backbone.marionette";
import RoutableBehavior from "../../../behaviors/routable";
import TooltipBehavior from "../../../behaviors/tooltip";
import templates from "../../../utils/templates";
import Collection from "../../../collections/menu-items";

const LEAF_NODE_CLASS = "leaf-node";
const DISABLED_CLASS = "disabled";

const DEFAULTS = {
  childViewContainer: "ul",
  tagName: "li",
  template: templates.find("layout", "side_menu_item"),
};

class View extends Marionette.CompositeView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  behaviors() {
    return [
      { behaviorClass: TooltipBehavior },
      { behaviorClass: RoutableBehavior },
    ];
  }

  initialize() {
    const { children, name, enabled } = this.model.toJSON();

    // create collection from children node
    this.collection = new Collection(children);

    //add leaf-node class to leaf nodes
    if (!children.length) {
      if (name !== "collapse") this.$el.addClass(LEAF_NODE_CLASS);
    }

    // add disabled flag when necessary
    if (!enabled) {
      this.$el.addClass(DISABLED_CLASS);
    }
  }

  onBeforeRender() {
    const { parentId, defaultRoute, children } = this.model.toJSON();
    const hasParent = !!parentId;

    // handle default route, if any.
    if (defaultRoute) {
      // mark parent node active
      if (children.length) {
        this.$el.addClass("active");
      }

      // mark link selected
      hasParent && this.$el.addClass("selected");
    }

    // unset icon when no children exist
    if (!children.length && hasParent) {
      this.model.setIcon(null);
    }
  }
}

export { View as default };
